  <div class="id-verification-modal">
    <div class="modal-header">
      <h4 class="modal-title">ID Verification</h4>
    </div>

    <div class="modal-body d-flex align-items-center">
      <div class="flex-fill">
        <div class="mt-4">
          <button class="btn btn-primary w-100 mb-2" (click)="startVerification()" 
          [disabled]="!personaSettings?.TemplateId || !personaSettings?.EnvironmentId">Verify Remote Customers</button>
          <button class="btn btn-outline-primary w-100" (click)="verifyInStore()">Verify In-Store Customers</button>
        </div>
      </div>

      <div class="verification-image ms-4">
        <img src="assets/images/IDVerification.svg" alt="ID Verification" class="id-image">
      </div>
    </div>
  </div>